<template>
  <div>
    <Header></Header>
    <loginheader flagg='1' num='6'></loginheader>
    <div class="details-con">
      <router-link to='/Catalog'>
        <div class="details-con-one">
          <img src="../../img/tupian.png" alt="" class="details-con-one-left">
          <div class="details-con-one-right">
            <p class="details-con-one-right-p">进击的巨人</p>
            <p class="details-con-one-right-p1">作者：高桥留美子</p>
            <p class="details-con-one-right-p1">题材： 武侠/魔幻</p>
            <p class="details-con-one-right-p1">状态：已完结</p>
            <p class="details-con-one-right-p2">迷手游，能在二次元世界中的
              不能白扰的外国人数的胸，都
              一天实然被线 门的监龙公...</p>
            <p class="details-con-one-right-p3">更新至：<span class="details-con-one-right-span">第183话 讨伐黄金</span></p>
          </div>
        </div>
      </router-link>
    </div>
    <Fotter></Fotter>
  </div>
</template>

<script>
  import Header from '../Header.vue'
  import Fotter from '../Fotter.vue'
  import loginheader from '../loginheader.vue'
  export default {
    name: 'App',
    components: {
      Header,
      Fotter,
      loginheader

    },

  }
</script>

<style>
  .details-con{
    display: flex;
    justify-content: center;
    padding:100px;
  }
 .details-con-one {
    width: 380px;
    height: 250px;
    margin-right: 20px;
    margin-top: 30px;
    display: flex;
  }

  .details-con-one-left {
    width: 180px;
    height: 250px;
    margin-right: 16px;
    border-radius: 8px;
  }

  .details-con-one-right {
    width: 180px;
    position: relative;
  }

  .details-con-one-right-p {
    font-size: 18px;
    font-weight: bold;
  }

  .details-con-one-right-p1 {
    font-size: 14px;
    margin-top: 16px;
  }

  .details-con-one-right-p2 {
    font-size: 14px;
    margin-top: 16px;
    color: #808080;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .details-con-one-right-p3 {
    font-size: 14px;
    color: #808080;
    position: absolute;
    bottom: 0;
  }

  .details-con-one-right-span {
    font-size: 14px;
    color: #28A3B1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cartoon/details.vue